import { z } from 'zod';
import { RoomExtraSchema } from '@features/rooms/schemas';

const legacyOptionSchema = z.object({
  label: z.string(),
  value: z.number(),
});

export const ExtraSchema = RoomExtraSchema.and(
  z.object({
    isSelected: z.boolean().optional(),
    quantity: z.number(),
    option: z.union([legacyOptionSchema, z.number()]).optional(),
    optionSelections: z
      .object({
        selections: z.array(z.object({ optionId: z.string(), guestId: z.string().optional() })),
        applyToAll: z.boolean(),
      })
      .optional(),
    guestSelections: z.array(z.string()).optional(),
  })
);
export const ExtrasSchema = z.array(ExtraSchema).optional();

export type OvernightPackageRoomExtras = z.infer<typeof ExtrasSchema>;
export type OvernightPackageRoomExtra = z.infer<typeof ExtraSchema>;
